import { Script_ListingFragment, Sdk } from '../../__generated__/sdk.generated'

export function useListingQueries(sdk: Sdk) {
  async function fetchListingByForeignId(source: {
    appId: string
    foreignId: string
  }): Promise<Script_ListingFragment | null> {
    const result = await sdk.DeveloperAppListingQuery({
      developerAppId: source.appId,
      foreignId: source.foreignId,
    })

    return result.developerApp?.listing ?? null
  }

  async function fetchListingById(
    id: string
  ): Promise<Script_ListingFragment | null> {
    const { listing } = await sdk.ListingQuery({ listingId: id })

    return listing
  }

  return { fetchListingByForeignId, fetchListingById }
}
